import { useIntl } from '@capsicum/common';
import { useSurveyById } from '@capsicum/features/survey/shared';

const PARTNER_LOGO = 'partner_logo';

export const useSurveyUnstakeScreen = ({ surveyId }: { surveyId: string }) => {
	const { isSurveyLoading, surveyData, surveyError } = useSurveyById(surveyId);

	const { $t } = useIntl();

	const isLoading = isSurveyLoading;
	const isError = surveyError || !surveyData;

	if (isLoading || isError) {
		return {
			isError,
			// GET request(s)
			isLoading
		} as const;
	}
	const partnerLogo = surveyData.images?.find(image => image.imageType?.type === PARTNER_LOGO)?.url || '';

	const stakingContractAddress = surveyData.stakingSmartContractAddress;
	const tokenContractAddress = surveyData.currencySmartContractAddress;

	const tokenLimit = surveyData.tokenLimit;

	const intlTitle = $t('survey.unstake.title');
	const intlDescription = $t('survey.unstake.description');
	const intlConfirm = $t('survey.unstake.button');
	const intlDisclaimer = $t('survey.unstake.disclaimer');

	return {
		intlConfirm,
		intlDescription,
		intlDisclaimer,
		// TRANSLATIONS
		intlTitle,
		isError,
		// GET request(s)
		isLoading,
		partnerLogo,
		stakingContractAddress,
		tokenContractAddress,
		tokenLimit
	};
};
